/**
 * @generated SignedSource<<2ca62e4c4ec1b4960d7d74736b645bd5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type morningStudioArticleFooterQuery$variables = {
  applicationId: string;
  articleTypeId: string;
  entityUuid: string;
  topicEntityUuid?: string | null;
  withTopic: boolean;
};
export type morningStudioArticleFooterQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"morningStudioArticleFooterDisplayQuery">;
};
export type morningStudioArticleFooterQuery = {
  response: morningStudioArticleFooterQuery$data;
  variables: morningStudioArticleFooterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "applicationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "articleTypeId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicEntityUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withTopic"
  }
],
v1 = {
  "kind": "Variable",
  "name": "entityUuid",
  "variableName": "entityUuid"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = [
  (v8/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": "size1200x800",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "1200x800"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": "style(filter:{\"style\":\"1200x800\"})"
    },
    {
      "alias": "size768x768",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "768x768"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": "style(filter:{\"style\":\"768x768\"})"
    },
    {
      "alias": "size540x360",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "540x360"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": "style(filter:{\"style\":\"540x360\"})"
    },
    {
      "alias": "size320x240",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "320x240"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": "style(filter:{\"style\":\"320x240\"})"
    },
    {
      "alias": "size80x80",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "80x80"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": "style(filter:{\"style\":\"80x80\"})"
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": [
    (v16/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v21 = [
  (v18/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": (v21/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v21/*: any*/),
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v26 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": "articleTypes",
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v26/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v26/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v28/*: any*/),
    (v29/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v26/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v23/*: any*/),
    (v4/*: any*/),
    (v15/*: any*/),
    (v3/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": (v10/*: any*/),
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v7/*: any*/),
        (v24/*: any*/),
        (v25/*: any*/),
        (v27/*: any*/),
        (v30/*: any*/),
        (v31/*: any*/)
      ],
      "type": "Base",
      "abstractKey": "__isBase"
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v23/*: any*/),
        (v4/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "types",
      "storageKey": null
    },
    (v4/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "AUTHOR_IMAGE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "118x118"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": "style(filter:{\"style\":\"118x118\"})"
        }
      ],
      "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v7/*: any*/),
        (v24/*: any*/),
        (v15/*: any*/),
        (v25/*: any*/),
        (v27/*: any*/),
        (v30/*: any*/),
        (v31/*: any*/)
      ],
      "type": "Base",
      "abstractKey": "__isBase"
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printHeadline",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/),
    (v27/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v37/*: any*/),
        (v28/*: any*/),
        (v29/*: any*/)
      ],
      "type": "Article",
      "abstractKey": null
    },
    (v31/*: any*/)
  ],
  "type": "Base",
  "abstractKey": "__isBase"
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVideoContent",
      "storageKey": null
    },
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            (v4/*: any*/),
            (v3/*: any*/),
            (v22/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v37/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flattenTypeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveArticle",
      "kind": "LinkedField",
      "name": "tmpLiveArticle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    (v29/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v40 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
},
v41 = [
  (v4/*: any*/)
],
v42 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v2/*: any*/),
    (v24/*: any*/),
    (v15/*: any*/),
    (v25/*: any*/),
    (v27/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/)
  ],
  "type": "Base",
  "abstractKey": "__isBase"
},
v43 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isContent"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "morningStudioArticleFooterQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "applicationId",
            "variableName": "applicationId"
          },
          {
            "kind": "Variable",
            "name": "articleTypeId",
            "variableName": "articleTypeId"
          },
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "topicEntityUuid",
            "variableName": "topicEntityUuid"
          },
          {
            "kind": "Variable",
            "name": "withTopic",
            "variableName": "withTopic"
          }
        ],
        "kind": "FragmentSpread",
        "name": "morningStudioArticleFooterDisplayQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "morningStudioArticleFooterQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              (v1/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "article",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Sponsor",
                "kind": "LinkedField",
                "name": "sponsor",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "seriesContainer",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "series",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/)
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v41/*: any*/),
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v41/*: any*/),
                    "type": "Podcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v41/*: any*/),
                    "type": "Video",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v42/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v43/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "withTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "entityUuid",
                    "variableName": "topicEntityUuid"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "articleTypeIds.0",
                            "variableName": "articleTypeId"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "articleTypeIds"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "exclude"
                  },
                  {
                    "fields": [
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "applicationIds.0",
                            "variableName": "applicationId"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "applicationIds"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "ContentConnection",
                "kind": "LinkedField",
                "name": "contents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/),
                          (v43/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v4/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v42/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1344b2759c6a2ae368d6d59166c392b2",
    "id": null,
    "metadata": {},
    "name": "morningStudioArticleFooterQuery",
    "operationKind": "query",
    "text": "query morningStudioArticleFooterQuery(\n  $applicationId: String!\n  $articleTypeId: String!\n  $entityUuid: String!\n  $topicEntityUuid: String\n  $withTopic: Boolean!\n) {\n  ...morningStudioArticleFooterDisplayQuery_GztoB\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  name\n  types\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"118x118\"}) {\n      url\n    }\n  }\n}\n\nfragment authorNameAuthor on Author {\n  ...entityLink\n  name\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment cardContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  urlAlias\n  ...articleCommentArticle\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent on Content {\n  __isContent: __typename\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n    size320x240: style(filter: {style: \"320x240\"}) {\n      url\n    }\n    size80x80: style(filter: {style: \"80x80\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentItemRenderContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...contentCoverImageContent\n  ...contentActionBarContent\n  ...contentPublishedDateContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentHeadlineContent\n  ...contentPrintHeadlineContent\n  ...contentTopicLinkContent\n  ...contentLiveTagContent\n  ...contentAuthorLinkContent\n  ...primaryContentItemContent\n  ...secondaryContentItemContent\n  ...searchContentItemContent\n  ...opinionContentItemContent\n  ...cardContentItemContent\n  ...morningStudioContentItemContent\n  ...hooksUseContentSponsorContent\n  ...postiesPrimaryContentItemContent\n  ...postiesSecondaryContentItemContent\n  ...postiesSectionPrimaryContentItemContent\n  ...postiesSectionSecondaryContentItemContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n}\n\nfragment contentLiveTagContent on Content {\n  __isContent: __typename\n  ... on Article {\n    flattenTypeIds\n    tmpLiveArticle {\n      status\n      id\n    }\n  }\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      relatedNewsletters {\n        ...helpersMassageToNewsletterItemNewsletter\n        id\n      }\n      id\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentPrintHeadlineContent on Content {\n  __isContent: __typename\n  printHeadline\n}\n\nfragment contentPublishedDateContent on Content {\n  __isContent: __typename\n  publishedDate\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  summary {\n    text\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment entityLink on Base {\n  __isBase: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ...helpersAppBarVariantArticle\n  ...helpersAppBarAdStatusBase\n}\n\nfragment helpersAppBarAdStatusBase on Base {\n  __isBase: __typename\n  ... on Section {\n    __typename\n    ...helpersStyleSectionContent\n  }\n}\n\nfragment helpersAppBarVariantArticle on Base {\n  __isBase: __typename\n  ...helpersArticleSections\n  ...helpersCheckIsLongReadArticle\n  ...helpersCheckIsMorningStudioArticle\n  ...helpersCheckIsPhotoEssayArticle\n  ...helpersStyleArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersArticleSections on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsLongReadArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsMorningStudioArticle on Article {\n  sponsorType\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPhotoEssayArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersStyleArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHelperContent\n  ... on Article {\n    ...helpersStyleArticle\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n  authors {\n    entityId\n    types\n    id\n  }\n  flag\n}\n\nfragment hooksUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment morningStudioArticleFooterDisplayQuery_GztoB on Query {\n  article(filter: {entityUuid: $entityUuid}) {\n    entityId\n    topics {\n      entityId\n      sponsor {\n        name\n        id\n      }\n      id\n    }\n    ...helpersCheckIsMainTopicContent\n    seriesContainer {\n      socialHeadline\n      headline\n      ...entityLink\n      series {\n        __typename\n        ... on Content {\n          __isContent: __typename\n          entityId\n          ...contentItemRenderContent\n        }\n        ... on Article {\n          id\n        }\n        ... on Podcast {\n          id\n        }\n        ... on Video {\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n  topic(filter: {entityUuid: $topicEntityUuid}) @include(if: $withTopic) {\n    ...entityLink\n    name\n    contents(first: 10, filter: {applicationIds: [$applicationId]}, exclude: {articleTypeIds: [$articleTypeId]}) {\n      edges {\n        node {\n          __typename\n          entityId\n          ...contentItemRenderContent\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment morningStudioContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment opinionContentItemContent on Content {\n  __isContent: __typename\n  ...hooksContentHelperContent\n  ...entityLink\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...authorNameAuthor\n    id\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment postiesPrimaryContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...contentCoverImageContent\n}\n\nfragment postiesSecondaryContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...contentCoverImageContent\n}\n\nfragment postiesSectionPrimaryContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...contentCoverImageContent\n}\n\nfragment postiesSectionSecondaryContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...contentCoverImageContent\n}\n\nfragment primaryContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  urlAlias\n  publishedDate\n}\n\nfragment searchContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment secondaryContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n}\n"
  }
};
})();

(node as any).hash = "01c7be63c5fb5527ecf372f9d0d77860";

export default node;
